<mat-form-field>
    <input #numericInput matInput type="text"
        (focus)="numericInput.select()"
        (change)="handleUpdate($event.target.value)"
        (keyup)="handleUpdate($event.target.value)"
        (blur)="handleOnBlur()"
        [disabled]="isDisabled"
        [style.width.px]="width>0 ? width : 'unset'"
        autocomplete="off"/>
    <span *ngIf="numericType == numericTypes.CURRENCY" matPrefix>$&nbsp;</span>
    <span matSuffix *ngIf="numericType == numericTypes.CURRENCY && (value == null || value == undefined)">.{{ "0".repeat(maxDecimals) }}</span>
    <span matSuffix *ngIf="numericType == numericTypes.PERCENT">%</span>
</mat-form-field>
